/**
 * Accessible names for the header's icon buttons that carry an unread badge
 * (UX 1.0d, WCAG 2.5.3 "label in name").
 *
 * The badge number is visible text inside the button, so the button's name
 * must contain it: "Sõnumid" on a button showing "3" fails axe
 * `label-content-name-mismatch`. The name is the label alone while there is
 * nothing unread — and then the badge is not rendered at all (MUI keeps the
 * last number in an invisible badge, which would be text again).
 */

/** MUI Badge's default `max`. */
export const BADGE_MAX = 99;

/** What the badge shows for `count` — `99+` past the max, as MUI renders it. */
export function badgeText(count: number, max = BADGE_MAX): string {
  return count > max ? `${max}+` : String(count);
}

type Translate = (key: string, options: Record<string, unknown>) => string;

/** `label`, or `label, unread: N` with N exactly as the badge shows it. */
export function unreadLabel(t: Translate, label: string, count: number): string {
  if (count <= 0) return label;
  return t('common:ui.shell.unreadLabel', {
    label,
    unread: badgeText(count),
    defaultValue: '{{label}}, lugemata: {{unread}}',
  });
}
